import { render, staticRenderFns } from "./ChatWorkbench.vue?vue&type=template&id=25eb8c55&scoped=true"
import script from "./ChatWorkbench.vue?vue&type=script&lang=js"
export * from "./ChatWorkbench.vue?vue&type=script&lang=js"
import style0 from "./ChatWorkbench.vue?vue&type=style&index=0&id=25eb8c55&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25eb8c55",
  null
  
)

export default component.exports